import { Box, Stack, Typography, useTheme } from "@mui/material";
import founder from "assets/images/onboarding/founder.png";
import welcomeDiamond from "assets/images/onboarding/welcome-diamond.webp";
import { Avatar } from "components";

export const OnboardingWelcome = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        gap: "24px",
        color: "inherit",
        overflowY: "auto",
      }}
    >
      <Stack direction="row" alignItems={"center"} gap="4px" width="100%">
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.secondary["purple-tint"],
          }}
        >
          Welcome to DeskDay
        </Typography>
        <img
          src={welcomeDiamond}
          alt="welcome diamond"
          style={{
            width: "32px",
            height: "32px",
          }}
        />
      </Stack>
      <Stack gap="20px">
        <Stack direction="row" alignItems={"center"} gap="6px" color="inherit">
          <Typography variant="body-medium" color="inherit">
            Hi! I&apos;m
          </Typography>
          <Avatar
            fullname="Jobin Johny"
            src={founder}
            style={{
              width: "24px",
              height: "24px",
            }}
          />
          <Typography variant="subtitle1" color="inherit">
            Jobin,
          </Typography>
          <Typography variant="body-medium" color="inherit">
            founder of DeskDay.
          </Typography>
        </Stack>
        <Typography variant="body-medium" color="inherit">
          We built DeskDay around a simple idea. Support should happen where
          users already work; not inside outdated portals or endless email
          threads.
        </Typography>
        <Typography variant="body-medium" color="inherit">
          Your users should be able to raise tickets in a few clicks from Teams,
          desktop, or mobile. And your techs should have a frictionless
          experience that helps them focus on solving problems, not navigating
          complex systems.
        </Typography>
        <Typography variant="body-medium" color="inherit">
          DeskDay brings the whole service flow together, from ticket to
          billing, while AI helps your team with productivity.
        </Typography>
        <Typography variant="body-medium" color="inherit">
          Before we get you started, we’d love to learn about your business so
          we can tailor the experience for you.
        </Typography>
      </Stack>
      <Typography
        variant="body-medium"
        color={theme.palette.primitive.brand.purple["500"]}
      >
        Let&apos;s build this together.
      </Typography>
    </Box>
  );
};
